export default "<ion-content>\n  <ion-router-outlet></ion-router-outlet>\n</ion-content>\n";